import { post, get, put, del as requestDel } from '@/utils/request';

// 新增/修改租户
export function TenantAdd(Data) {
  if (Data.id && Data.id > 0) {
    return put('/api/v1/tenant/' + Data.id, Data);
  }
  return post('/api/v1/tenant', Data); 
}

// 租户分页列表
export function TenantList(Data) {
  return get('/api/v1/tenant/page', Data); 
}

// 删除租户
export function TenantDel(Data) {
  const id = typeof Data === 'object' ? Data.id : Data;
  return requestDel('/api/v1/tenant/' + id); 
}

// 租户详情
export function TenantDetail(Data) {
  const id = typeof Data === 'object' ? Data.id : Data;
  return get('/api/v1/tenant/detail', { id }); 
}

// 租户下拉列表
export function TenantDropdownList() {
  return get('/api/v1/tenant/list');
}
